import axios from "axios";
import { authenticatedHeader } from "../DefaultConfig";
import { StatisticsURL } from "../Services";
import { HideAwaiting, ShowAwaiting } from "../../util/Awaiting";
import { getFromStorage, saveToStorage } from "../../util/StorageUtil";

export async function getHotKeywordByTopic(topic: string, hour: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/keyword/view/hot-by-topic",
    {
      topic: topic,
      hour: hour,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getStandardTopics() {
  if (getFromStorage("standardTopics") == null) {
    var res = await axios.get(StatisticsURL + "api/topic/all");
    saveToStorage("standardTopics", res.data, 3000000);
    return res.data;
  }
  return await getFromStorage("standardTopics");
}

export async function getContentByTopic(topic: string, days: number) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/content/view/by-topic",
    {
      topic: topic,
      days: days,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}

export async function getTopicSpecializationPageData(
  topic: string,
  hour: number
) {
  ShowAwaiting();
  var res = await axios.post(
    StatisticsURL + "api/statistics/topic/specialization/detail",
    {
      topic: topic,
      hour: hour,
    },
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
